import type { MonitorResponse } from "./types";

export function parseDisplayPolicy(
  value: unknown,
): MonitorResponse["display_policy"] {
  if (!value || typeof value !== "object")
    throw new Error("Invalid Queue refresh policy");
  const policy = value as MonitorResponse["display_policy"];
  const bounds: [
    Exclude<keyof typeof policy, "stale_after_seconds">,
    number,
    number,
  ][] = [
    ["list_refresh_seconds", 5, 120],
    ["detail_refresh_seconds", 3, 120],
    ["refresh_error_backoff_max_seconds", 30, 600],
    ["refresh_error_backoff_multiplier", 2, 4],
    ["display_policy_max_age_seconds", 60, 3600],
    ["page_size", 1, 100],
    ["max_page_size", 1, 100],
  ];
  for (const [key, min, max] of bounds) {
    if (
      !Number.isInteger(policy[key]) ||
      policy[key] < min ||
      policy[key] > max
    )
      throw new Error("Invalid Queue refresh policy");
  }
  if (policy.page_size > policy.max_page_size)
    throw new Error("Invalid Queue refresh policy");
  // Optional until every API release carries it; when present it is typed.
  if (
    policy.stale_after_seconds !== undefined &&
    (!Number.isInteger(policy.stale_after_seconds) ||
      policy.stale_after_seconds < 3600 ||
      policy.stale_after_seconds > 2592000)
  )
    throw new Error("Invalid Queue refresh policy");
  return policy;
}
